import owd from 'owd/owd';

export default class FsPlayer extends owd.Component {
	init() {
		this.$toggle = this.$element.find('[data-fs-player-toggle]');
		this.$video = this.$element.find('[data-fs-player-video]');
		this.$rf = this.$element.find('[data-fs-player-rf]').length ? this.$element.find('[data-fs-player-rf]') : this.$video;
		this.$videos = this.$video.add(this.$rf);
		this.$progress = this.$element.find('[data-fs-player-progress]');
		this.$progressBar = this.$element.find('[data-fs-player-progress-bar]');
		this.$switch = this.$element.find('[data-fs-player-switch]');
		this.$fullscreen = this.$element.find('[data-fs-player-fullscreen]');
		this.video = this.$video[0];
		this.rf = this.$rf[0];

		this.ready = this.$video.data('videoApi').getVideoElementPromise()
			.then((video) => {
				this.video = video;

				if (!this.$video.data('videoApi').supportsFullscreen()) {
					this.$fullscreen.hide();
					this.$fullscreen.prev().css('marginRight', 0);
				}

				return this.$rf.data('videoApi').getVideoElementPromise();
			})
			.then((video) => {
				this.rf = video;

				return Promise.resolve();
			})
			.then(() => {
				this.swiper = $('[data-slider-fullscreen]').data('swiperInstance');

				this.$top = this.dom.$body.find('[data-fs-top]');

				this.progressWidth = this.$progress.outerWidth();
				this.hideNavTimeout;
				this.isRfActiveActive = false;
				this.currVideo = this.video;
				this.prevVideo = this.rf;
				this.currTime = 0;

				this.$progressMousedown = false;
				this.$progressMousein = false;

				this.bind();

				return Promise.resolve();
			});
	}

	play() {
		this.ready.then(() => {
			$(this.currVideo).data('videoApi').play();
			this.$element.addClass('is-playing');
		});
	}

	pause() {
		this.ready.then(() => {
			$(this.currVideo).data('videoApi').pause();
			this.$element.removeClass('is-playing');
			this.$element.removeClass('has-nav-hidden');
			this.$top.removeClass('is-hidden');

			this.resetHideTimeout();
		});
	}

	togglePlay() {
		if (this.currVideo.paused) {
			this.play();
		} else {
			this.pause();
		}
	}

	handleProgress() {
		this.currTime = this.currVideo.currentTime;
	    const percent = (this.currTime / this.currVideo.duration) * 100;
	    this.$progressBar.css('transform', `translateX(${percent}%)`);
	}

	scrub(e) {
	    const scrubTime = ((e.clientX - this.$progress.offset().left) / this.progressWidth) * this.currVideo.duration;
	    this.currVideo.currentTime = scrubTime;
		this.currTime = scrubTime;
	}

	openFullscreen() {
	    $(this.currVideo).data('videoApi').fullScreen();
	}

	resetSwitch() {
		this.currVideo = this.video;
		this.prevVideo = this.rf;

		this.$element.removeClass('is-rf-playing');
	}

	switchVideos() {
		// if (!this.isRfActive) {
		// 	this.isRfActive = true;
		// 	this.currVideo = this.rf;
		// 	this.prevVideo = this.video;
		// } else {
		// 	this.isRfActive = false;
		// 	this.currVideo = this.video;
		// 	this.prevVideo = this.rf;
		// }
		let prevVideo = this.prevVideo;
		let currVideo = this.currVideo;

		this.currTime = this.currVideo.currentTime;
		this.prevVideo.currentTime = this.currTime;

		// $(this.prevVideo).animate( { volume: 0 }, 1000, () => {
		$(currVideo).data('videoApi').pause();
		// })

		this.currTime = this.currVideo.currentTime;
		this.prevVideo.currentTime = this.currTime;

		$(prevVideo).data('videoApi').play();

		// $(this.currVideo).animate( { volume: 1 }, 1000)

		if (!this.isRfActive) {
			this.isRfActive = true;
			this.currVideo = this.rf;
			this.prevVideo = this.video;
		} else {
			this.isRfActive = false;
			this.currVideo = this.video;
			this.prevVideo = this.rf;
		}

		this.$element.toggleClass('is-rf-playing');
	}

	setHideTimeout() {
		this.hideNavTimeout = setTimeout(() => {
			this.$element.addClass('has-nav-hidden');
			this.$top.addClass('is-hidden');
		}, 1000)
	}

	resetHideTimeout() {
		clearTimeout(this.hideNavTimeout);
		this.$element.removeClass('has-nav-hidden');
		this.$top.removeClass('is-hidden');
	}

	bind() {
		this.on('click', this.$videos, () => {
			this.togglePlay();
		})

		this.on('mousemove click touchstart touchmove touchend', this.$element.parent(), (e) => {
			if (!this.currVideo.paused && !this.currVideo.ended) {
				this.resetHideTimeout();
				this.setHideTimeout();
			}
		});

		this.video.addEventListener('timeupdate', () => {
			this.handleProgress();
		});

		this.video.addEventListener('ended', () => {
			this.resetHideTimeout();
			this.pause();
		});

		if (this.rf) {
			this.rf.addEventListener('timeupdate', () => {
				this.handleProgress();
			});

			this.rf.addEventListener('ended', () => {
				this.pause();
			});
		}

		this.on('fs-state-play', () => {
			this.$element.addClass('is-playing');
			this.resetHideTimeout();
		})

		this.on('fs-state-pause', (e) => {
			this.$element.removeClass('is-playing');
			this.$element.removeClass('has-nav-hidden');
			this.$top.removeClass('is-hidden');

			this.resetHideTimeout();
		})

		this.on('click', this.$toggle, () => {
			this.togglePlay();
		})

		this.on('click', this.$progress, (e) => {
			this.scrub(e);
		})

		this.on('click', this.$fullscreen, () => {
			this.openFullscreen();
		})

		this.on('mousemove', this.$progress, (e) => {
			e.stopPropagation();
			this.progressMousedown && this.progressMousein && this.scrub(e);
		})

		this.on('mousedown', this.$progress, (e) => {
			e.stopPropagation();
			this.progressMousedown = true;
		})

		this.on('mouseup', this.$progress, (e) => {
			e.stopPropagation();
			this.progressMousedown = false;
		})

		this.on('mouseenter', this.$progress, (e) => {
			e.stopPropagation();
			this.progressMousein = true;
		})

		this.on('mouseleave', this.$progress, (e) => {
			e.stopPropagation();
			this.progressMousein = false;
			this.progressMousedown = false;
		})

		this.on('click', this.$switch, () => {
			this.switchVideos();
		})

		this.on('slideChange', this.swiper, () => {
			this.resetHideTimeout();

			if (this.video) {
				$(this.video).data('videoApi').pause();
			}

			if (this.rf) {
				$(this.rf).data('videoApi').pause();
			}
		})

		this.on('close-fs-modal', this.dom.$window, () => {
			this.resetSwitch();

			if (this.video) {
				$(this.video).data('videoApi').pause();
			}

			if (this.rf) {
				$(this.rf).data('videoApi').pause();
			}
		})
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('fs-player', {
	component: FsPlayer
});
